import { render, staticRenderFns } from "./PriceTableRequest.vue?vue&type=template&id=2578d094"
import script from "./PriceTableRequest.vue?vue&type=script&lang=js"
export * from "./PriceTableRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports